export const getArgumentsEndpoint = ({
    budgetProposalId,
    resourceSoftwareId,
}: {
    budgetProposalId: string;
    resourceSoftwareId: string;
}) =>
    `budget_proposals/${budgetProposalId}/resource/${encodeURIComponent(
        resourceSoftwareId,
    )}/arguments`;
